import {
  AppContent,
  AppHeader,
  PopoverItem,
  SettingsIcon,
  SSOUser,
  BreadCrumbs,
  crumb,
} from '@trufla-technology/trumarket-react-design-system';
import { NavLink, Switch, useHistory, useLocation } from 'react-router-dom';
import { NewCompany } from './forms/NewCompany';
import { NewUser } from './forms/NewUser';
import { UsersList } from './pages/Configurations/UserListFile';
import {
  useAuthContext,
  useBrandingContext,
} from '@trufla-technology/trufla-trudomain/dist/lib';
import { TopLevelSearch } from './components/TopLevelSearch';
import packageJson from '../../package.json';
import './style.scss';
import { TruRoute } from './TruRoute';
import { Dashboard } from './pages/Dashboard';
import { CompaniesList } from './pages/CompaniesList';
import { ClientList } from './pages/ClientList';
import { Reports } from './pages/Reports';
import { AssignProductToBranch } from './pages/CompanyProducts/AssignProductToBranch';
import { Configurations } from './pages/Configurations/index';
import { useEffect, useState } from 'react';

import { UserView } from './pages/UserView';
export const MainContent = () => {
  const history = useHistory();
  const { user, logOut, isPermitted } = useAuthContext();
  const location = useLocation();
  const { pathname } = location;
  const [theCrumbs, setCrumbs] = useState<crumb[]>([]);
  const {
    branding: { logoUrl },
  } = useBrandingContext();

  useEffect(() => {
    let crumbList: crumb[] = [];
    crumbList.push({
      label: 'Configurations',
      path: '/configurations/company-details/',
    });

    setCrumbs(crumbList);
  }, [pathname]);

  const dropdown = (
    <>
      {user?.username && <p className="tru-user-info">{user?.username}!</p>}
      <p className="tru-user-info">v{packageJson.version}</p>
      {user?.email && <p className="tru-user-info">{user?.email}!</p>}
    </>
  );
  return (
    <>
      <div className="tru-header-and-content">
        <AppHeader
          logoUrl={logoUrl}
          user={user as SSOUser}
          logOut={logOut}
          title="truMarket"
          links={<></>}
          handleLogoClick={() =>
            history.push('/configurations/company-details/')
          }
          dropdownItems={dropdown}
          childrenRight={
            <>
              {isPermitted('listClients') && <TopLevelSearch />}
              <NavLink
                activeClassName="active"
                className="setting-icon"
                to="/configurations/company-details/"
              >
                <SettingsIcon fill="var(--tru-white)" width="20px" />
              </NavLink>
            </>
          }
        />
        <BreadCrumbs crumbs={theCrumbs} />
        <AppContent>
          <Switch>
            <TruRoute
              path="/users/:key"
              component={UserView}
              permission={['listUsers', 'listLocations', 'getTeams']}
            />
            <TruRoute path="/users" component={UsersList} />
            <TruRoute path="/companies" component={CompaniesList} />
            <TruRoute path="/dashboard" component={Dashboard} />
            <TruRoute path="/clients" component={ClientList} />
            <TruRoute path="/reports" component={Reports} />
            <TruRoute path="/configurations/*" component={Configurations} />
            <TruRoute
              path="/"
              redirect="configurations/company-details/"
              permission={['getCompany']}
            />
          </Switch>
        </AppContent>
      </div>
      <PopoverItem
        title="New User"
        match="new=user"
        component={NewUser}
        onClose={() => history.push(history.location.pathname)}
      />
      <PopoverItem
        title="New Company"
        match="new=company"
        component={NewCompany}
      />
      {isPermitted('assignProductDefinitionToGroup') && (
        <PopoverItem
          title="Product Branches"
          match="assign-branch"
          component={AssignProductToBranch}
        />
      )}
    </>
  );
};
